// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"187":"e759a4b1","279":"2ec9223b","852":"52a317b2","931":"f85e448a"}[chunkId] + ".css";
};